module.exports = __webpack_public_path__ + "static/media/Business-River-Logo.026489fd.png";